import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './LocationItem.module.scss'
import LocationAddress from '../../LocationDetails/LocationAddress/LocationAddress'
import SearchLocationContext from '../../../context/SearchLocationContext'
import ApplicationContext from '../../../context/ApplicationContext'
import LocationBadges from '../../LocationBadges/LocationBadges'
import Spacer from '../../Spacer/Spacer'
import EventsBar from '../../EventsBar/EventsBar'

const LocationItem = props => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)
    const [searchLocationData] = useContext(SearchLocationContext)
    const hasBadges =
        props?.item?.badgeCertifiedFitter ||
        props?.item?.badgeCustomFittingExperience ||
        props?.item?.badgeFitterOfTheYear ||
        props?.item?.badgeFittingExperience

    const address = {
        state: props?.item?.state,
        compliment: props?.item?.compliment,
        postalCode: props?.item?.postalCode,
        street: props?.item?.street,
        city: props?.item?.city,
    }

    return (
        <div className={styles.locationItemContainer}>
            <div className={styles.locationItemContainer_header}>
                <h3 className={styles.locationItemTitle}>{props?.item?.name}</h3>

                {props?.item?.distance !== null && (
                    <span className={styles.distance}>{`${props?.item?.distance} ${searchLocationData.unitType ?? applicationData.unitType}`}</span>
                )}
            </div>

            {hasBadges && (
                <div className={styles.badgesContainer}>
                    <LocationBadges
                        certifiedFitter={props?.item?.badgeCertifiedFitter}
                        pldFitter={props?.item?.badgeCustomFittingExperience}
                        fitterOfTheYear={props?.item?.badgeFitterOfTheYear}
                        fittingExperience={props?.item?.badgeFittingExperience}
                    />
                </div>
            )}

            <LocationAddress phone={props?.item?.formattedNumber} address={address} />

            {props?.item?.events && props.item.events.length > 0 && (
                <>
                    <Spacer />
                    <EventsBar item={props?.item} localizations={localizations} />
                </>
            )}
        </div>
    )
}

LocationItem.propTypes = {
    item: PropTypes.object,
}

export default LocationItem
